import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectReportReducer } from '../reducers';

export const selectProjectReportFeature = createFeatureSelector<ProjectReportReducer.ProjectReportState>(ProjectReportReducer.featureName);

export const selectProjectReport = createSelector(selectProjectReportFeature, (state: ProjectReportReducer.ProjectReportState) => state.item);
export const selectDataSource = createSelector(selectProjectReportFeature, (state: ProjectReportReducer.ProjectReportState) => state.dataSource);
